<div [hidden]="this.frmGroup.get(this.configData.name)['hidden']" #accordionContainer id="accordionContainer" >
    <div [ngClass]="{'dhl-accordion-container': true, 'accordion-expand': isActive && !configData.isError, 'accordion-collapse': !isActive,
'accordion-error': configData.isError || configData.errorMessageFlag, 'accordion-success': configData.isError === false && configData.errorMessageFlag === false }">
    <div *ngIf="configData && (isHandset$ | async) === false" class="dhl-accordion" (click)="toggleAccordian($event)">
        <div fxFlex="4%" [ngClass]="{'user-icon' : configData.isError === undefined, 'error-icon' : configData.isError || configData.errorMessageFlag, 'success-icon': configData.isError === false && configData.errorMessageFlag === false }">
        </div>
        <div fxFlex="40%" class="label">
            <span>{{configData.label}}</span>
	    <span class="text-danger" *ngIf="configData.errorMessageFlag"> - ({{configData.errorCount}} {{configData.errorMessages}})</span>
        </div>
        <div fxFlex="56%" class="sub-label">
            <span>{{configData.accordionLabel}}</span>
        </div>
        <div fxFlex="3%" [ngClass]="{'arrow-icon': true, 'open': isActive, 'closed': !isActive}">
        </div>
    </div>

    <div *ngIf="configData && (isHandset$ | async)" class="dhl-accordion" (click)="toggleAccordian($event)">
        <div fxFlex="77%">
            <div class="label">
                <span>{{configData.label}}</span>
            </div>
            <div class="sub-label">
                <span>{{configData.accordionLabel}}</span>
            </div>
        </div>
        <div fxFlex="11%" class="user-icon"></div>
        <div fxFlex="12%" [ngClass]="{'arrow-icon': true, 'open': isActive, 'closed': !isActive}">
        </div>
    </div>

    <div class="dhl-accordion-content-wrapper" id="accordionContent" [hidden]="!isActive">
        <div class="accordion-action">
            <div style="display: inline-block;margin-left: 14px;" *ngFor="let action of configData.accordionAction">
                <button type="button" (click)="accordionAction(action)" class="dhl-button-v2 buttons-secondary-small-v2">
                    <span>{{action.view.label}}</span>
                </button>
            </div>
        </div>

        <div class="dhl-accordion-content" *ngIf="configData">
            <!-- <div *ngFor="let row of getFormTableControls(); let rowIndex = index"> -->
                <app-form-field *ngFor="let control of configData.controls;let ctrlIndex=index" [configData]="control"
                [ngClass]="getColsClass(control.cols)" [frmGroup]="getFormTableControls(ctrlIndex)"></app-form-field>
            <!-- </div>             -->
        </div>
<!--        <div class="action-buttons-wrapper">
            <div class="">
                <button class="button-previous"> Previous </button>
            </div>
            <div class="">
                <button class="button-next"> Next </button>
            </div>
        </div>-->
    </div>
</div>
    <div *ngIf="configData.isError" [ngClass]="{'dhl-accordion-error-container': true}">
        <div class="error-icon"><span class="error-icon"></span> </div>
        <div> <span class="alert-message">Alert: </span>
        <span>{{configData.errorMessage}}</span>
        </div>
    </div>
    <div *ngIf="!configData.isError && configData.showSuccessMessage"
     [ngClass]="{'dhl-accordion-error-container': true}">
    <div class="error-icon">
        <span class="error-icon"></span>
    </div>
    <div>
        <span class="alert-message">Alert: </span>
        <span>{{configData.successMessage}}</span>
    </div>
</div>
</div>
